/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Scorecard } from './Scorecard.js';
import {
    ScorecardFromJSON,
    ScorecardFromJSONTyped,
    ScorecardToJSON,
} from './Scorecard.js';

/**
 * 
 * @export
 * @interface ListScorecardsResponse
 */
export interface ListScorecardsResponse {
    /**
     * 
     * @type {Array<Scorecard>}
     * @memberof ListScorecardsResponse
     */
    data?: Array<Scorecard>;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ListScorecardsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ListScorecardsResponse interface.
 */
export function instanceOfListScorecardsResponse(value: object): boolean {
    return true;
}

export function ListScorecardsResponseFromJSON(json: any): ListScorecardsResponse {
    return ListScorecardsResponseFromJSONTyped(json, false);
}

export function ListScorecardsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListScorecardsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScorecardFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ListScorecardsResponseToJSON(value?: ListScorecardsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScorecardToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

